import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api/axios';
import { useLoading } from '../components/LoadingProvider';
import { getPublicImgUrl } from '../utils/common';

function AboutUs() {
    document.title = 'Varosa - About Us';
    const { setIsLoading } = useLoading();
    const navigate = useNavigate();
    const [doctorList, setDoctorList] = useState([]);
    useEffect(() => {
        setIsLoading(true);
        api.get('/doctor/search?top_list=1').then((response) => {
            setDoctorList(response?.data?.data?.doctors);
        }).finally((e) => {
            setIsLoading(false);
        });
    }, []);
    return (
        <>
            {/* Header Start */}
            <div className="container-fluid bg-breadcrumb">
                <div className="container text-center py-5" style={{maxWidth: '900px'}}>
                    <h3 className="text-white display-3 mb-4 wow fadeInDown" data-wow-delay="0.1s">About Us</h3>
                    <ol className="breadcrumb justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        <li className="breadcrumb-item active text-primary">About</li>
                    </ol>    
                </div>
            </div>
            {/* Header End */}

            {/* About Start */}
            <div className="container-fluid about bg-light py-5">
                <div className="container py-5">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-5 wow fadeInLeft" data-wow-delay="0.2s">
                            <div className="about-img pb-5 ps-5">
                                <img src={getPublicImgUrl()+"/about-1.jpg"} className="img-fluid rounded w-100" style={{objectFit: 'cover'}} alt="" />
                                <div className="about-img-inner">
                                    <img src={getPublicImgUrl()+"/about-2.jpg"} className="img-fluid rounded-circle w-100 h-100" alt="" />
                                </div>
                                <div className="about-experience">15 years experience</div>
                            </div>
                        </div>
                        <div className="col-lg-7 wow fadeInRight" data-wow-delay="0.4s">
                            <div className="section-title text-start mb-5">
                                <h4 className="sub-title pe-3 mb-0">About Us</h4>
                                <h1 className="display-3 mb-4">We are Ready to Help Improve Your Treatment.</h1>
                                <p className="mb-4">Varosa Healthcare is a modern telemedicine platform dedicated to making healthcare accessible, convenient, and reliable for everyone. We combine advanced digital technology with compassionate medical expertise, enabling patients to receive trusted care from the comfort of their homes. Our mission is to break down barriers to healthcare—whether distance, time, or cost—and provide seamless access to certified doctors and specialists.</p>
                                <p className="mb-4">With a strong focus on patient well-being, data security, and personalized support, Varosa Healthcare is transforming the way people connect with healthcare services. We strive to create a healthier community where quality medical assistance is just a click away. At Varosa Healthcare, we believe in care that’s closer, quicker, and tailored to you. Your health, our priority—always.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* About End */}

            {/* Team Start */}
            <div className="container-fluid team py-5">
                <div className="container py-5">
                    <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="sub-style">
                            <h4 className="sub-title px-3 mb-0">Meet our team</h4>
                        </div>
                        <h1 className="display-3 mb-4">Physiotherapy Services from Professional Therapist</h1>
                    </div>
                    <div className="row g-4 justify-content-center">
                        {doctorList.map((doctor, index) => (
                        <div className="col-md-6 col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay="0.1s" key={index}>
                            <div className="team-item rounded">
                                <div className="team-img rounded-top h-100 border border-primary border-bottom-0 pt-3">
                                    <img src={doctor.profile_picture || getPublicImgUrl()+"/doctor_2785482.png"} className="img-fluid rounded-top w-100" alt={doctor.name} style={{maxHeight: '250px', objectFit: 'contain'}} />
                                </div>
                                <div className="team-content text-center border border-primary border-top-0 rounded-bottom p-4">
                                    <h5>{doctor.name}</h5>
                                    {doctor.qualification && (<p className="mb-3">
                                        <b>Qualification: </b> 
                                        {doctor.qualification?.length > 100 ? doctor.qualification.slice(0, 100) : doctor.qualification}
                                        {doctor.qualification?.length > 100 ? (
                                            <>
                                            <span className={`d-none rest-qualification-${doctor.id}`}>{doctor.qualification.slice(100)}</span>
                                            &nbsp;&nbsp;
                                            <button onClick={(e) => { 
                                                e.preventDefault();
                                                var elements = document.getElementsByClassName(`rest-qualification-${doctor.id}`);
                                                if(elements.length > 0){
                                                    if(elements[0].classList.contains("d-none")){
                                                        elements[0].classList.remove("d-none");
                                                        e.target.textContent = 'Read Less';
                                                    }else{
                                                        elements[0].classList.add("d-none");
                                                        e.target.textContent = 'Read More';
                                                    }
                                                }
                                            }} className="btn btn-outline-success btn-sm ml-3">Read More</button>
                                            </>
                                        ) : ''}
                                    </p>)}
                                    {doctor.bio && (<p className="mb-3">
                                        <b>Bio: </b> 
                                        {doctor.bio?.length > 100 ? doctor.bio.slice(0, 100) : doctor.bio}
                                        {doctor.bio?.length > 100 ? (
                                            <>
                                            <span className={`d-none rest-bio-${doctor.id}`}>{doctor.bio.slice(100)}</span>
                                            &nbsp;&nbsp;
                                            <button onClick={(e) => { 
                                                e.preventDefault();
                                                var elements = document.getElementsByClassName(`rest-bio-${doctor.id}`);
                                                if(elements.length > 0){
                                                    if(elements[0].classList.contains("d-none")){
                                                        elements[0].classList.remove("d-none");
                                                        e.target.textContent = 'Read Less';
                                                    }else{
                                                        elements[0].classList.add("d-none");
                                                        e.target.textContent = 'Read More';
                                                    }
                                                }
                                            }} className="btn btn-outline-success btn-sm ml-3">Read More</button>
                                            </>
                                        ) : ''}
                                    </p>)}
                                    <p className="mb-3"><b>Specializations:</b> {doctor.specializations.map((specialization) => (
                                        <span key={specialization} className="badge bg-primary me-1">{specialization}</span>
                                    ))}</p>
                                    <p className="mb-3"><b>Consultation Fees: <i>&#8377;{doctor.consultation_fee}</i></b></p>
                                    <hr />
                                    <button className="btn btn-primary text-white" onClick={(e) => { 
                                        e.preventDefault();
                                        navigate(`/dashboard/patient/appointment/book/?d=${doctor.id}`)
                                    }}>CONSULT NOW</button>
                                </div>
                            </div>
                        </div>))}
                    </div>
                </div>
            </div>
            {/* Team End */}

            {/* Feature Start */}
            <div className="container-fluid feature py-5">
                <div className="container py-2">
                    <div className="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="sub-style">
                            <h4 className="sub-title px-3 mb-0">Why Choose Us</h4>
                        </div>
                        <h1 className="display-3 mb-4">Why Choose Us? Get Your Life Style Back</h1>
                        <p className="mb-0">Choosing Varosa means choosing convenience, reliability, and modern healthcare solutions. With its patient-focused approach and advanced telemedicine platform, Varosa ensures that quality medical care is always within reach.</p>
                    </div>
                    <div className="row g-4 justify-content-center">
                        <div className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="row-cols-1 feature-item p-4">
                                <div className="col-12">
                                    <div className="feature-icon mb-4">
                                        <div className="p-3 d-inline-flex bg-white rounded">
                                            <img className="img-fluid rounded-top w-100" alt="" src={getPublicImgUrl()+"/online-doctor.png"} />
                                        </div>
                                    </div>
                                    <div className="feature-content d-flex flex-column">
                                        <h5 className="mb-4">Easy Access to Doctors</h5>
                                        <p className="mb-0">Varosa allows patients to consult qualified doctors from the comfort of their home. No need to travel long distances or wait in crowded clinics.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="row-cols-1 feature-item p-4">
                                <div className="col-12">
                                    <div className="feature-icon mb-4">
                                        <div className="p-3 d-inline-flex bg-white rounded">
                                            <img className="img-fluid rounded-top w-100" alt="" src={getPublicImgUrl()+"/Support.png"} />
                                        </div>
                                    </div>
                                    <div className="feature-content d-flex flex-column">
                                        <h5 className="mb-4">24/7 Medical Support</h5>
                                        <p className="mb-0">Healthcare needs can arise anytime. Varosa provides round-the-clock access to medical consultations so you can get help whenever you need it.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                            <div className="row-cols-1 feature-item p-4">
                                <div className="col-12">
                                    <div className="feature-icon mb-4">
                                        <div className="p-3 d-inline-flex bg-white rounded">
                                            <img className="img-fluid rounded-top w-100" alt="" src={getPublicImgUrl()+"/save-time.png"} />
                                        </div>
                                    </div>
                                    <div className="feature-content d-flex flex-column">
                                        <h5 className="mb-4">Time-Saving Service</h5>
                                        <p className="mb-0">With telemedicine, patients can avoid long waiting hours at hospitals and get quick consultations through their phone or computer.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="row-cols-1 feature-item p-4">
                                <div className="col-12">
                                    <div className="feature-icon mb-4">
                                        <div className="p-3 d-inline-flex bg-white rounded">
                                            <img className="img-fluid rounded-top w-100" alt="" src={getPublicImgUrl()+"/affortable.png"} />
                                        </div>
                                    </div>
                                    <div className="feature-content d-flex flex-column">
                                        <h5 className="mb-4">Affordable Healthcare</h5>
                                        <p className="mb-0">Varosa offers cost-effective consultation services compared to traditional hospital visits, making healthcare more accessible to everyone.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="row-cols-1 feature-item p-4">
                                <div className="col-12">
                                    <div className="feature-icon mb-4">
                                        <div className="p-3 d-inline-flex bg-white rounded">
                                            <img className="img-fluid rounded-top w-100" alt="" src={getPublicImgUrl()+"/private consultation.png"} />
                                        </div>
                                    </div>
                                    <div className="feature-content d-flex flex-column">
                                        <h5 className="mb-4">Secure and Private Consultations</h5>
                                        <p className="mb-0">Patient privacy is a top priority. Varosa ensures secure communication and confidential handling of medical information.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="row-cols-1 feature-item p-4">
                                <div className="col-12">
                                    <div className="feature-icon mb-4">
                                        <div className="p-3 d-inline-flex bg-white rounded">
                                            <img className="img-fluid rounded-top w-100" alt="" src={getPublicImgUrl()+"/digital-prescription.png"} />
                                        </div>
                                    </div>
                                    <div className="feature-content d-flex flex-column">
                                        <h5 className="mb-4">Digital Prescriptions</h5>
                                        <p className="mb-0">After consultation, patients receive digital prescriptions instantly, which can be used at pharmacies without delay.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.7s">
                            <div className="row-cols-1 feature-item p-4">
                                <div className="col-12">
                                    <div className="feature-icon mb-4">
                                        <div className="p-3 d-inline-flex bg-white rounded">
                                            <img className="img-fluid rounded-top w-100" alt="" src={getPublicImgUrl()+"/follow up.png"} />
                                        </div>
                                    </div>
                                    <div className="feature-content d-flex flex-column">
                                        <h5 className="mb-4">Follow-Up Care Made Simple</h5>
                                        <p className="mb-0">Patients can easily schedule follow-up consultations with their doctors to monitor their health progress.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 col-xl-3 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="row-cols-1 feature-item p-4">
                                <div className="col-12">
                                    <div className="feature-icon mb-4">
                                        <div className="p-3 d-inline-flex bg-white rounded">
                                            <img className="img-fluid rounded-top w-100" alt="" src={getPublicImgUrl()+"/accessibility.png"} />
                                        </div>
                                    </div>
                                    <div className="feature-content d-flex flex-column">
                                        <h5 className="mb-4">Accessible from Anywhere</h5>
                                        <p className="mb-0">Whether you are at home, at work, or traveling, Varosa enables you to connect with doctors anytime using your smartphone or computer.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Feature End */}
        </>
    );
}

export default AboutUs;